import { TOnChangeStringPrimitiveFormData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/TOnChangePrimitiveFormData'

export const changeMeetingObjective =
  (onChangePrimitiveFormData: TOnChangeStringPrimitiveFormData) => (value: string) => {
    if (value.length <= 80) {
      onChangePrimitiveFormData()('MeetingObjective')(value)
    }
  }
